import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Confirmation from './Confirmation';
import { getInvestmentsData } from 'store/features/investments/actions';
import { getInvestorInformation } from 'store/features/investors/actions';
import { AppDispatch, RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  status: state.investments.status,
  wantInvestBySociety: state.account.wantInvestBySociety,
  successSociety: state.society.success,
  successInvestor: state.investor.success,
  investorInformation: state.investor.fetch.status,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ getInvestmentsData, getInvestorInformation }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);
